import Components from './../Component';

export default class CookieBanner extends Components {

    constructor($) {
        super($);
    }

    init(index, element) {

        this.element = element;

       this.hideOrShow();

        this.$(element).find('#close-cookie-banner').on('click', function(e){
           this.saveCookiePreferences(true);
        }.bind(this));
    }

    hideOrShow(){
        let cookie = this.getCookie('cookie-close');

        if (cookie){
            this.$(this.element).addClass('hidden');
        }else{
            this.$(this.element).removeClass('hidden');
        }
    }

    getCookie (name) {
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    saveCookiePreferences(value){
        document.cookie = `cookie-close=${value}; path=/; max-age=${60 * 60 * 24 * 100};`;
        this.hideOrShow();
    }

}